import { render, staticRenderFns } from "./form-assign.vue?vue&type=template&id=63ac5584&scoped=true"
import script from "./form-assign.vue?vue&type=script&lang=js"
export * from "./form-assign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ac5584",
  null
  
)

export default component.exports